module.exports = __webpack_public_path__ + "static/media/youtube.a51ab7ed.svg";